import React, { ReactElement, ReactNode } from 'react';
import { IComponentCss } from '@tap/mui-ui';
import {
    Grid,
    Typography,
    Tooltip,
    Skeleton,
    CSSObject,
} from '@mui/material';

/*
*   Набор элементов для параметров отчета (прим. график Ганта)
*/

/*
*   Заголовок табов
*/
type ITabsTitle = {
    title: string | number | ReactElement,
}

const cssTabsTitle: IComponentCss = {
    title: {
        height: '82px',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'flex-start',
        color: '#212121 !important',
        padding: '12px 16px',
        fontSize: '14px',
        textTransform: 'none',
        fontWeight: 700,
        borderBottom: '1px solid #E0E0E0',
    },
};

export function TabsTitle({
    title,
}: ITabsTitle): ReactElement {
    return (
        <Grid container sx={cssTabsTitle.title}>
            {title}
        </Grid>
    )
}


/*
*   Название таба
*/
type ITabLabel = {
    title: string | number | ReactElement,
    subTitle: string | number | ReactElement,
    chipLabel?: string | number | ReactElement,
    chipTooltipLabel?: string | number | ReactElement,
}

const cssTabLabel: IComponentCss = {
    wrap: {
        alignItems: 'flex-start',
        width: '100%',
        textAlign: 'left',
        padding: '12px 16px',
        textTransform: 'none',
        fontWeight: 700,
        borderBottom: '1px solid #E0E0E0',
    },
    title: {
        lineHeight: 1.6,
        fontWeight: 700,
        color: '#212121 !important',
    },
    chipLabel: {
        lineHeight: 1.6, color: '#999999 !important', fontSize: '12px', paddingTop: '3px',
    },
    subTitle: {
        lineHeight: 1.3, color: '#999999 !important', fontSize: '12px',
    },
};

export function TabLabel({
    title,
    subTitle,
    chipLabel,
    chipTooltipLabel,
}: ITabLabel): ReactElement {
    return (
        <Grid container sx={cssTabLabel.wrap} >
            <Grid
                container
                alignContent='space-between'
                justifyContent='space-between'
            >
                {/* Заголовок таба */}
                <Typography sx={cssTabLabel.title}>
                    {title}
                </Typography>

                {/* Чип (метка) таба */}
                {chipLabel && chipTooltipLabel &&
                    <Tooltip title={<>{chipTooltipLabel}</>}>
                        <Typography sx={cssTabLabel.chipLabel}>
                            {chipLabel}
                        </Typography>
                    </Tooltip>
                }
            </Grid>

            {/* Подзаголовок таба */}
            <Typography sx={cssTabLabel.subTitle}>
                {subTitle}
            </Typography>
        </Grid>
    )
}


/*
*   Контент таба
*/
type ITabComponent = {
    title: string,
    children?: ReactNode,
    contentWrapStyle?: CSSObject,
}

const cssTabComponent: IComponentCss = {
    titleWrap: {
        height: '82px',
        width: '100%',
        borderBottom: '1px solid #E0E0E0',
        padding: '30px 16px 30px 16px',
        background: '#F9FBFA',
        borderRadius: '0px 4px 0px 0px',
    },
    title: { fontWeight: 700 },
    contentWrap: {
        padding: '16px 16px 16px 16px',
    },
}

export function TabComponent({
    title,
    children,
    contentWrapStyle,
}: ITabComponent): ReactElement {
    return (
        <>
            {/* Заголовок */}
            <Grid
                container
                sx={cssTabComponent.titleWrap}
                justifyContent='space-between'
            >
                <Typography
                    component='h3'
                    color='initial'
                    sx={cssTabComponent.title}
                >
                    {title}
                </Typography>
            </Grid>

            {/* Контент */}
            <Grid
                container
                sx={{
                    ...cssTabComponent.contentWrap,
                    ...contentWrapStyle,
                }}
            >
                {children}
            </Grid>
        </>
    )
}



/*
*   Цех.участок - подзаголовок таба.
*   Возвращает строку с количеством цехов, участков.
*/
export type IManufacturingSectorsQuantity = {
    workshops: number,
    sections: number,
}

export function manufacturingSectorsSubTitle(
    quantity: IManufacturingSectorsQuantity | undefined,
): string | ReactElement {
    return (
        quantity
            ? `Цехов: ${quantity?.workshops}, Участков: ${quantity?.sections}`
            : <Skeleton width='120px' />
    )
}


/*
*   Цех.участок - чип (метка).
*   Возвращает число с количеством выбранных участков.
*/
export function manufacturingSectorsChipLabel(
    quantityAllSectors: IManufacturingSectorsQuantity | undefined,
    selectedSectors: string[] | undefined = undefined,
): string | number | ReactElement {
    let quantity: 'все' | number | undefined
        = selectedSectors?.filter(s => s?.includes('.'))?.length;

    if (quantityAllSectors?.sections === quantity || quantity === 0)
        quantity = 'все';

    return (
        quantity !== undefined && quantityAllSectors !== undefined
            ? quantity
            : <Skeleton width='23px' />
    )
}
